import { ResourceTypeDtoMetaTypeEnum } from '@jooxter/api';

/** One kind per family of space (resource meta-type); MEETING and VISIO are both meeting rooms. */
export enum BookingKindEnum {
  Meeting = 'meeting',
  Booth = 'booth',
  Bubble = 'bubble',
  Desk = 'desk',
  Parking = 'parking',
  Vehicle = 'vehicle',
  Other = 'other',
}

const KIND_BY_META_TYPE: Record<ResourceTypeDtoMetaTypeEnum, BookingKindEnum> = {
  [ResourceTypeDtoMetaTypeEnum.Meeting]: BookingKindEnum.Meeting,
  [ResourceTypeDtoMetaTypeEnum.Visio]: BookingKindEnum.Meeting,
  [ResourceTypeDtoMetaTypeEnum.Booth]: BookingKindEnum.Booth,
  [ResourceTypeDtoMetaTypeEnum.Bubble]: BookingKindEnum.Bubble,
  [ResourceTypeDtoMetaTypeEnum.Desk]: BookingKindEnum.Desk,
  [ResourceTypeDtoMetaTypeEnum.Parking]: BookingKindEnum.Parking,
  [ResourceTypeDtoMetaTypeEnum.Vehicle]: BookingKindEnum.Vehicle,
  [ResourceTypeDtoMetaTypeEnum.Other]: BookingKindEnum.Other,
};

/** Unknown meta-type (resource types not loaded yet): a generic space, never a meeting. */
export const getBookingKind = (metaType?: ResourceTypeDtoMetaTypeEnum): BookingKindEnum =>
  metaType ? KIND_BY_META_TYPE[metaType] : BookingKindEnum.Other;

/** Font Awesome icon of each kind of booking — the same as the Spaces list (JxtResourceIcon). */
export const BOOKING_KIND_ICON: Record<BookingKindEnum, string> = {
  [BookingKindEnum.Meeting]: 'users',
  [BookingKindEnum.Booth]: 'phone',
  [BookingKindEnum.Bubble]: 'user-group',
  [BookingKindEnum.Desk]: 'desktop',
  [BookingKindEnum.Parking]: 'square-parking',
  [BookingKindEnum.Vehicle]: 'car',
  [BookingKindEnum.Other]: 'building',
};
